export const events = {
  sendFeedback: 'Send feedback',
}
